// extracted by mini-css-extract-plugin
export default {"redirectSpinner":"styles_redirectSpinner__FP+8e"};